export default class BloomCloseButton {
	static SELECTOR = 'span.et_bloom_close_button';

	start() {
		this.attachEventListeners();
	}

	attachEventListeners() {
		this.pressButtonEvent();
	}

	pressButtonEvent() {
		// Close modal with Enter key when keyboard focus is on close icon
		$('body').on('keydown', BloomCloseButton.SELECTOR, (e) => {
			if (e.key === 'Enter') {
				this.closeModal(BloomCloseButton.SELECTOR);
			}
		});

		if (coreAccessibility.enable_bloom_a11y_fixes) {
			// Close the modal with the Escape key
			document.addEventListener('keydown', (e) => {
				if (e.code === 'Escape') {
					this.closeModal(BloomCloseButton.SELECTOR);
				}
			});
		}
	}

	closeModal(element) {
		const $ = jQuery;
		const $popupContainer = $(element).parents().filter('.et_bloom_optin.et_bloom_flyin, .et_bloom_optin.et_bloom_popup').first();

		$popupContainer.addClass('et_bloom_exit_animation');
		setTimeout(() => {
			if ($popupContainer.hasClass('et_bloom_trigger_click')) {
				$popupContainer.removeClass('et_bloom_visible et_bloom_animated et_bloom_exit_animation');
			} else {
				$popupContainer.remove();
			}
		}, 400);

		$('body').removeClass('et_bloom_popup_active');
	}
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/bloom/controllers/bloom_close_button.js